import { render, staticRenderFns } from "./InheemsStart.vue?vue&type=template&id=316f724c&"
import script from "./InheemsStart.vue?vue&type=script&lang=js&"
export * from "./InheemsStart.vue?vue&type=script&lang=js&"
import style0 from "./InheemsStart.vue?vue&type=style&index=0&id=316f724c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports